import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./miscStyles.less";

const NoMachines: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: "center", marginTop: "10%" }}>
      <Button className="primary-button" onClick={() => navigate("/dashboard/new-machine")}>
        New Machine
      </Button>
      <div className="no-machine-page-text">You have 0 machines connected</div>
    </div>
  );
};

export default NoMachines;
